import firebase from 'firebase/compat/app';

const config = {
  apiKey: "AIzaSyCABboYg5L6icTrMA7xsY0LLf-gRxqAPZo",
  authDomain: "hilmanbinahmad.firebaseapp.com",
  databaseURL: "https://hilmanbinahmad-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "hilmanbinahmad",
  storageBucket: "hilmanbinahmad.appspot.com",
  messagingSenderId: "732832633420",
  appId: "1:732832633420:web:02e36f36a3401412905ae9",
  measurementId: "G-9CM8633K8R"
};

const firebaseConfig = firebase.initializeApp(config);

export default firebaseConfig;